import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Wizard } from './wizard'

const statefulWizardPropTypes = {
    classNames: PropTypes.shape({
        contentClassName: PropTypes.string,
        headerClassName: PropTypes.string,
        modalClassName: PropTypes.string,
        titleClassName: PropTypes.string
    }),
    onClose: PropTypes.func,
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.element,
            page: PropTypes.element.isRequired,
            subtitle: PropTypes.string.isRequired,
            title: PropTypes.string
        })
    ).isRequired,
    title: PropTypes.string
}

const defaultProps = {
    onClose: Function.prototype
}

class StatefulWizard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activeStep: 0,
            model: {}
        }

        this.setStep = this.setStep.bind(this)
        this.updateModel = this.updateModel.bind(this)
        this.onClose = this.onClose.bind(this)
    }

    render() {
        const {
            onClose,
            props: { ...props },
            setStep,
            state: { activeStep, model },
            updateModel
        } = this

        return <Wizard {...{ ...props, activeStep, model, onClose, setStep, updateModel }} />
    }

    onClose() {
        this.setState({
            activeStep: 0,
            model: {}
        })
        this.props.onClose()
    }

    setStep(activeStep) {
        this.setState({ activeStep })
    }

    updateModel(update) {
        this.setState({
            model: {
                ...this.state.model,
                ...update
            }
        })
    }
}

StatefulWizard.propTypes = statefulWizardPropTypes
StatefulWizard.defaultProps = defaultProps

export { StatefulWizard }
